import { Form, Input, Typography } from 'antd'
import { type RentalOrder } from '@super-mega/server/contracts/order'
import { AttachmentUpload } from '@/features/files/index.ts'

export function RentalAttachmentFields({
  isSaving,
  existingOrder
}: {
  isSaving: boolean
  existingOrder?: RentalOrder
}) {
  return (
    <section
      className="border-border bg-surface scroll-mt-24 rounded-xl border p-5 shadow-xs"
      id="section-rental-attachments"
    >
      <Typography.Title className="mb-1!" level={5}>
        附件与备注
      </Typography.Title>
      <Typography.Text type="secondary">补充本次租赁的附件和内部说明，方便后续跟进。</Typography.Text>
      <Form.Item className="mt-4" label="租赁附件" name="fileIds">
        <AttachmentUpload
          purpose="rentalAttachment"
          disabled={isSaving}
          maxCount={20}
          initialFiles={existingOrder?.attachments.map(({ file }) => ({
            id: file.id,
            name: file.originName || file.fileName,
            fileType: file.fileType,
            size: Number(file.fileSize)
          }))}
        />
      </Form.Item>
      <Form.Item label="内部备注" name="note">
        <Input.TextArea maxLength={5000} placeholder="例如：首月减免 200 元；每月 5 日前出账。" rows={3} showCount />
      </Form.Item>
    </section>
  )
}
